import cn from 'classnames'

import { useCurrency } from '../../../../utils/use-currency'

import { ExchangePairProps } from './exchange-pair.props'

import styles from './styles.module.scss'

import ExchangeIcon from './icons/exchange.svg'

export default function ExchangePair({ currencyPair, isLoading }: ExchangePairProps) {
  let currencyInfoFrom = null
  let currencyInfoTo = null

  if (!isLoading) {
    currencyInfoFrom = useCurrency({ code: currencyPair.currencyFrom.code, network: currencyPair.currencyFrom.network })
    currencyInfoTo = useCurrency({ code: currencyPair.currencyTo.code, network: currencyPair.currencyTo.network })
  }

  return isLoading ? (
    <div className={cn(styles.coin, { [styles.loading]: isLoading })}>
      <div className={styles.coin__content}>
        <img className={styles.coin__content__logo} />
        <div className={styles.coin__text}>
          <div className={styles.coin__text__part}></div>
          <div className={styles.coin__text__part}></div>
        </div>
      </div>
    </div>
  ) : (
    <div className={cn(styles.coin)}>
      <div className={styles.coin__container}>
        <div className={styles.coin__content}>
          <img
            className={styles.coin__content__logo}
            src={currencyInfoFrom?.logo_url}
            alt={`${currencyInfoFrom?.code} logo`}
          />
          <div className={styles.coin__text}>
            <h5>{currencyInfoFrom?.code}</h5>
          </div>
        </div>
        <img className={styles.container__exchangeIcon} src={ExchangeIcon} alt="Exchange icon" />
        <div className={styles.coin__content}>
          <img
            className={styles.coin__content__logo}
            src={currencyInfoTo?.logo_url}
            alt={`${currencyInfoTo?.code} logo`}
          />
          <div className={styles.coin__text}>
            <h5>{currencyInfoTo?.code}</h5>
          </div>
        </div>
      </div>
    </div>
  )
}
